<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed, inject } from 'vue'
import { OVERLAY_BACKDROP_Z_KEY, OVERLAY_Z_BASE } from '#ui-kit/lib/useOverlayStack'
import { OverlayBackdrop } from '#ui-kit/ui/overlay'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()

const backdropZ = inject(
  OVERLAY_BACKDROP_Z_KEY,
  computed(() => OVERLAY_Z_BASE),
)
</script>

<template>
  <OverlayBackdrop data-ui-sheet-overlay :class="props.class" :z-index="backdropZ">
    <slot />
  </OverlayBackdrop>
</template>
